<template>
  <div class="flex w-full" style="min-height: 720px;">
    <!-- Off-canvas menu for mobile, show/hide based on off-canvas menu state. -->
    <div class="fixed inset-0 flex z-40 lg:hidden bg-white" :class="{'hidden': !sidebarMenu }" role="dialog" aria-modal="true" >
      <div class="relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4  bg-slate-200">
        <div class="absolute top-0 right-0 -mr-12 pt-2">
          <button @click="sidebarMenu = false" type="button" class="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
            <span class="sr-only">Close</span>
            <!-- Heroicon name: outline/x -->
            <svg class="h-6 w-6 text-gray-900" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div class="flex-shrink-0 flex items-center px-4">
          <img class="h-8 w-auto" src="@/assets/icon.png" alt="Workflow">
        </div>
        <nav class="mt-5 flex-1 h-0 overflow-y-auto" aria-label="Sidebar">
          <div
            v-for="item in Menus"
            :key="item.menu"
            class="group flex flex-col space-y-1"
          >
            <div @click="handleMenu(item)" class="nav-item flex items-center px-2 py-2 text-sm font-medium rounded-md cursor-pointer" :class="(menu === item.menu || item.opened) ? 'bg-gray-100 text-gray-900' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'">
              <svg v-html="item.icon" :class="menu === item.menu ? 'text-gray-500' : 'text-gray-400 group-hover:text-gray-500'" class="mr-3 flex-shrink-0 h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true" v-if="!item.hasChildren"></svg>
              <svg :class="item.opened ? 'text-gray-500' : 'text-gray-400 group-hover:text-gray-500'" class="mr-3 flex-shrink-0 h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" v-if="item.hasChildren">
                <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" v-if="item.opened" />
                <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" v-else />
              </svg>
              {{ item.name }}
            </div>
            <template v-if="item.opened && item.hasChildren">
            <div
              v-for="child in item.children"
              :key="child.menu"
              @click="handleChildMenu(child)"
              :class="menu === child.menu ? 'bg-gray-100 text-gray-900' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'"
              class="group flex items-center px-2 pl-8 py-2 text-sm font-medium rounded-md cursor-pointer"
            >
              <svg v-html="child.icon" :class="menu === child.menu ? 'text-gray-500' : 'text-gray-400 group-hover:text-gray-500'" class="mr-3 flex-shrink-0 h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true"></svg>
              {{ child.name }}
            </div>
            </template>
          </div>
        </nav>
      </div>

      <div class="flex-shrink-0 w-14" aria-hidden="true" @click="sidebarMenu = false">
        <!-- Dummy element to force sidebar to shrink to fit close icon -->
      </div>
    </div>
    <div class="hidden md:flex md:w-64 md:flex-col md:absolute md:inset-y-0">
      <div class="flex flex-col flex-grow border-r border-gray-200 pt-5 bg-white overflow-y-auto">
        <div class="flex items-center flex-shrink-0 px-4">
          <!-- <img class="h-8 w-auto" src="@/assets/icon.png" alt="Workflow"> -->
          <h1 class="text-xl font-semibold text-gray-900 pl-6">用户中心</h1>
        </div>
        <div class="mt-5 flex-grow flex flex-col">
          <nav class="flex-1 px-2 pb-4 space-y-1">
            <div
              v-for="item in Menus"
              :key="item.menu"
              class="group flex flex-col space-y-1"
            >
              <div @click="handleMenu(item)" class="nav-item flex items-center px-2 py-2 text-sm font-medium rounded-md cursor-pointer" :class="(menu === item.menu || item.opened) ? 'bg-gray-100 text-gray-900' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'">
                <svg v-html="item.icon" :class="menu === item.menu ? 'text-gray-500' : 'text-gray-400 group-hover:text-gray-500'" class="mr-3 flex-shrink-0 h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true" v-if="!item.hasChildren"></svg>
                <svg :class="item.opened ? 'text-gray-500' : 'text-gray-400 group-hover:text-gray-500'" class="mr-3 flex-shrink-0 h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" v-if="item.hasChildren">
                  <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" v-if="item.opened" />
                  <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" v-else />
                </svg>
                {{ item.name }}
              </div>
              <template v-if="item.opened && item.hasChildren">
              <div
                v-for="child in item.children"
                :key="child.menu"
                @click="handleChildMenu(child)"
                :class="menu === child.menu ? 'bg-gray-100 text-gray-900' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'"
                class="group flex items-center px-2 pl-8 py-2 text-sm font-medium rounded-md cursor-pointer"
              >
                <svg v-html="child.icon" :class="menu === child.menu ? 'text-gray-500' : 'text-gray-400 group-hover:text-gray-500'" class="mr-3 flex-shrink-0 h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true"></svg>
                {{ child.name }}
              </div>
              </template>
            </div>
          </nav>
        </div>
      </div>
    </div>
    <div class="md:pl-64 flex flex-col flex-1 h-full" style="min-height: 650px;">
      <main class="flex-1" @click="userDropMenuShow = false">
        <div class="py-0">
          <Profile v-if="menu === 'home'" />
          <TaskList v-else-if="menu === 'task'" />
          <CommentList v-else-if="menu === 'comment'" />
          <MarketList v-else-if="menu === 'market'" />
          <Feedback v-else-if="menu === 'feedback'" />
          <Extend v-else-if="menu === 'extend'"></Extend>
          <ExtendMine v-else-if="menu === 'extend_mine'"></ExtendMine>
          <Score v-else-if="menu === 'score_list'" />
          <ArticleList v-else-if="menu === 'article'" />
          <ArticleCommentList v-else-if="menu === 'article_comment'"></ArticleCommentList>
          <HelpCommentList v-else-if="menu === 'help_comment'" />
          <RegCodeList v-else-if="menu === 'reg_code'" />
          <OrderList v-else-if="menu === 'order_list'" />
          <VipOrderList v-else-if="menu === 'vip_list'"></VipOrderList>
          <FbOrderList v-else-if="menu === 'fb_order_list'"></FbOrderList>
          <FbFreeList v-else-if="menu === 'fb_free_list'"></FbFreeList>
          <FbToken v-else-if="menu === 'fb_token'"></FbToken>
          <RebateUser v-else-if="menu === 'rebate_user'"></RebateUser>
          <RebateList v-else-if="menu === 'rebate_list'"></RebateList>
          <RebateWithdrawal v-else-if="menu === 'rebate_withdrawal'"></RebateWithdrawal>
          <ShareList v-else  />
        </div>
      </main>
    </div>
    <Notify ref="notify" />
    <Loading ref="loading" v-show="appLoading"></Loading>
  </div>
</template>

<script>
import TaskList from './pages/Task.vue'
import ShareList from './pages/Share.vue'
import CommentList from './pages/Comment.vue'
import MarketList from './pages/Market.vue'
import RegCodeList from './pages/RegCode.vue'
import OrderList from './pages/OrderList.vue'
import FbFreeList from './pages/FbFreeList.vue'
import VipOrderList from './pages/VipOrderList.vue'
import FbOrderList from './pages/FbOrderList.vue'
import Feedback from './pages/Feedback.vue'
import Profile from './pages/Profile.vue'
import Extend from './pages/Extend.vue'
import ExtendMine from './pages/ExtendMine.vue'
import Score from './pages/Score.vue'
import ArticleList from './pages/Article.vue'
import ArticleCommentList from './pages/ArticleComment.vue'
import HelpCommentList from './pages/HelpComment.vue'
import FbToken from './pages/FbToken.vue'
import Menus from './menus'
import Notify from './components/Notification.vue'
import Loading from './components/Loading.vue'
import { getCurrentUser } from './api/App'
import RebateUser from './pages/FbFreeList.vue'
import RebateList from './pages/rebate/List.vue'
import RebateWithdrawal from './pages/rebate/Withdrawal.vue'
export default {
  name: 'WwwUc',
  components: { FbToken, TaskList, Profile, Notify, ShareList, CommentList, Feedback, Extend,
    Score, ArticleList, HelpCommentList, Loading, MarketList, RegCodeList, OrderList, VipOrderList,
    FbOrderList, FbFreeList, RebateUser, RebateList, RebateWithdrawal, ExtendMine, ArticleCommentList
  },
  mounted () {
    if (this.$store.state.token) {
      this.getUser()
    }
    // window.localStorage.setItem('hyy_www_token', '350cc582e46e44419099990c9ac14dac')
    this.$nextTick(() => {
      document.body.appendChild(this.$refs.loading.$el)
    })
    if (window.location.hash.length) {
      const menu = window.location.hash.replace('#', '')
      this.Menus.forEach((i, index) => {
        if (i.menu === menu) {
          this.Menus[index].opened = true
        }
        if (i.children && i.children.length) {
          const child = i.children.find(c=> c.menu === menu)
          if (child) this.Menus[index].opened = true
        }
      })
      this.menu = menu
    }
  },
  data () {
    return {
      Menus,
      menu: 'home',
      user: null,
      sidebarMenu: false,
      userDropMenuShow: false
    }
  },
  methods: {
    handleChildMenu (child) {
      this.menu = child.menu
      window.location.hash = `#${this.menu}`
    },
    handleMenu (item) {
      this.Menus.map((i) => { i.opened = false })
      if (item.hasChildren) {
        item.opened = true
        this.menu = item.children[0].menu
      } else {
        this.menu = item.menu
      }
      window.location.hash = `#${this.menu}`
    },
    getUrlParam (key) {
      const params = new URLSearchParams(location.search)
      return params.get(key)
    },
    logout () {
      this.$store.commit('LOG_OUT')
      window.location.href = '/index.html'
    },
    getUser () {
      getCurrentUser().then(res => {
        this.user = res.data.data
        this.$store.dispatch('hyy_www_user', res.data.data)
      }).catch(err => { console.log(err) })
    },
    notifyShow (msg = { title: '', desc: '', timeout: 3000 }) {
      console.log(msg)
      this.$refs.notify.show(msg)
    }
  },
  computed: {
    appLoading () {
      return this.$store.state.appLoading
    }
  },
  watch: {
    '$store.state.notify': {
      deep: true,
      immediate: true,
      handler (val) {
        if (val.title.length) {
          this.$nextTick(() => {
            this.notifyShow(this.$store.state.notify)
            this.$store.state.notify.title = ''
          })
        }
      }
    }
  }
}
</script>
